import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import TrackOrder from './TrackOrder';
import { useOrderManagementApi } from '../../../hooks/useOrderManagementApi';

const TrackOrderPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const initialTrackingOrder = (location.state as any)?.trackingOrder;
  // const openEdit = Boolean((location.state as any)?.openEdit);
  const [trackingOrder, setTrackingOrder] = useState<any>(initialTrackingOrder);
  const { getAllOrders } = useOrderManagementApi();

  const userContext = useMemo(() => {
    try {
      const storedUser = localStorage.getItem('userData');
      const parsed = storedUser ? JSON.parse(storedUser) : null;
      const userId = parsed?.userId || '';
      const rawUserType = parsed?.userType || '';
      const userType = (rawUserType === 'superAdmin' || rawUserType === 'subadmin') ? 'admin' : rawUserType;
      return { userId, userType };
    } catch {
      return { userId: '', userType: '' };
    }
  }, []);

  // Short polling every 5 seconds to refresh tracking details
  useEffect(() => {
    const orderId = trackingOrder?.orderId || initialTrackingOrder?.orderId;
    if (!orderId) return;
    let timer: any;

    const fetchLatest = async () => {
      try {
        const response: any = await getAllOrders({
          userId: userContext.userId,
          userType: 'Admin',
          page: 1,
          limit: 1,
          orderId,
        });
        const latest = response?.data?.orders?.[0];
        if (latest) {
          setTrackingOrder(latest);
        }
      } catch {
        // ignore polling errors
      }
    };

    fetchLatest();
    timer = setInterval(fetchLatest, 30000);

    return () => clearInterval(timer);
  }, [getAllOrders, userContext.userId, userContext.userType, initialTrackingOrder?.orderId, trackingOrder?.orderId]);

  if (!trackingOrder) {
    return (
      <Box p={2}>
        <Button variant="outlined" onClick={() => navigate(-1)} sx={{ mb: 2 }}>
          Back
        </Button>
        <Typography>No tracking information available.</Typography>
      </Box>
    );
  }

  return (
    <Box p={2}>
      <Button variant="outlined" onClick={() => navigate(-1)} sx={{ mb: 2 }}>
        Back
      </Button>
      <TrackOrder trackingOrder={trackingOrder} />
      {/* If in future an edit modal needs to auto-open we can use openEdit flag */}
    </Box>
  );
};

export default TrackOrderPage;


